import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { t } from "../i18n";
import { fadeUp, stagger, viewport } from "../motion";

function Counter({ target }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const dur = 1400;
    const t0 = performance.now();
    const tick = (now) => {
      const prog = Math.min((now - t0) / dur, 1);
      const eased = 1 - Math.pow(1 - prog, 3);
      setVal(Math.round(eased * target));
      if (prog < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [inView, target]);
  return <span ref={ref}>{val}%</span>;
}

export default function Stats() {
  const s = t.de.stats;
  return (
    <section data-testid="stats" className="py-24 md:py-32 bg-[#F8F9FA]">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewport} className="text-center max-w-2xl mx-auto mb-16">
          <motion.span variants={fadeUp} className="text-xs font-semibold uppercase tracking-[0.25em] text-gold-600 block mb-4">{s.overline}</motion.span>
          <motion.h2 variants={fadeUp} className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-navy-900">{s.title}</motion.h2>
        </motion.div>

        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewport} className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-6">
          {s.items.map((item, i) => (
            <motion.div key={i} variants={fadeUp} data-testid={`stat-${i}`} className="text-center min-w-0">
              <div className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-outfit font-light gold-gradient-text mb-3 tabular-nums break-words leading-tight px-1">
                {item.v === "100%" ? <Counter target={100} /> : item.v}
              </div>
              <div className="w-8 h-px bg-gold-300 mx-auto mb-3" />
              <p className="text-slate-600 font-medium">{item.l}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
